import Reveal from "@/components/base/Reveal";
import { VELLORA_URL, WHATSAPP_URL } from "@/mocks/navigation";

export default function VelloraCall() {
  return (
    <section className="w-full bg-secondary-100" aria-label="Modelo demonstrativo Vellora Studio">
      <div className="px-4 py-14 md:px-8 md:py-20">
        <Reveal className="mx-auto max-w-4xl">
          <div className="rounded-lg border border-secondary-300 bg-background-50 p-6 text-center md:p-12">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-[11px] uppercase tracking-[0.22em] text-primary-700">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-store-2-line text-[11px]" />
              </span>
              Projeto demonstrativo
            </span>

            <h2 className="mt-6 font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
              Gostou desta experiência para o seu negócio?
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              Este é um modelo demonstrativo de loja de moda criado pela Vellora Studio. Sua marca pode ter uma
              experiência personalizada, com identidade própria, catálogo, carrinho e atendimento pelo WhatsApp.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-whatsapp-line text-lg" />
                Quero uma loja para minha marca
              </a>
              <a
                href={VELLORA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-400 px-7 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                Conhecer a Vellora Studio
              </a>
            </div>

            <p className="mt-6 text-xs text-foreground-500">
              A Amora Belle é uma demonstração comercial e não representa uma loja real em funcionamento.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}